import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  ENumber,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutNavbarLogoLeft = {
  factory: EElement({
    id: 'f4c5a2ce-5cd6-0e31-ccd4-effdaa76e764',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('div'),
      styleBlockIds: EList([EText('7817eb1c-47cc-bc73-19ae-9055d6e3651f')]),
      children: EList([
        EElement({
          id: '08e896a3-bb32-5cfb-f0ca-6c918ef7e787',
          type: qualify(
            Plugins.name('Navbar'),
            Component.name('NavbarWrapper')
          ),
          data: ERecord({
            tag: EEnum('div'),
            navbar: ERecord({
              animation: EEnum('default'),
              collapse: EText('medium'),
              docHeight: EBoolean(false),
              duration: ENumber(400),
              easing: EEnum('ease'),
              easing2: EEnum('ease'),
              noScroll: EBoolean(false),
              type: EText('wrapper'),
            }),
            styleBlockIds: EList([
              EText('5092b234-0393-484c-746f-3689c63e3687'),
              EText('7ee04e3f-5f4a-63a9-0ad8-36694f4f50d9'),
            ]),
            temp: ERecord({
              navbar: ERecord({
                menu: EEnum('hide'),
              }),
            }),
            children: EList([
              EElement({
                id: '08e896a3-bb32-5cfb-f0ca-6c918ef7e788',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('81b59867-fdee-430e-3436-1014d50622b3'),
                  ]),
                  children: EList([
                    EElement({
                      id: '08e896a3-bb32-5cfb-f0ca-6c918ef7e789',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('d9243737-6519-27e3-5f94-48a95680754d'),
                        ]),
                        children: EList([
                          EElement({
                            id: '08e896a3-bb32-5cfb-f0ca-6c918ef7e78a',
                            type: qualify(
                              Plugins.name('Navbar'),
                              Component.name('NavbarBrand')
                            ),
                            data: ERecord({
                              navbar: ERecord({
                                type: EText('brand'),
                              }),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse('{"mode":"external"}'),
                              }),
                              eventIds: EList([]),
                              styleBlockIds: EList([
                                EText('c447af01-1144-3fbb-1b22-b79b330b748d'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '08e896a3-bb32-5cfb-f0ca-6c918ef7e78b',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.companyLogoPlaceholder),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"6272f0b0c0d70f780eaaa29c"}'
                                      ),
                                    }),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '08e896a3-bb32-5cfb-f0ca-6c918ef7e78c',
                            type: qualify(
                              Plugins.name('Navbar'),
                              Component.name('NavbarMenu')
                            ),
                            data: ERecord({
                              tag: EEnum('nav'),
                              navbar: ERecord({
                                type: EText('menu'),
                              }),
                              attr: ERecord({
                                role: EText('navigation'),
                              }),
                              styleBlockIds: EList([
                                EText('0a4327ab-4bc9-e91e-1ec2-996cd50f31d5'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'b004192c-70ee-4f5a-fd64-1298a0ed3b76',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('List')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('ul'),
                                    list: ERecord({
                                      type: EText('list'),
                                      unstyled: EBoolean(true),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        'c567917e-2cd3-7da4-4a7a-22de5ae608f4'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'b004192c-70ee-4f5a-fd64-1298a0ed3b77',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('ListItem')
                                        ),
                                        data: ERecord({
                                          list: ERecord({
                                            type: EText('item'),
                                          }),
                                          text: EBoolean(false),
                                          children: EList([
                                            EElement({
                                              id: 'd0a0b804-501f-9f6c-23c8-e5582aa17120',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Link')
                                              ),
                                              data: ERecord({
                                                button: EBoolean(false),
                                                eventIds: EList([]),
                                                link: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Basic'),
                                                    typeName('Link')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"mode":"external","url":"#"}'
                                                  ),
                                                }),
                                                block: EText(''),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'afc274d7-2178-837c-3ef8-2c663643cdf3'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'd0a0b804-501f-9f6c-23c8-e5582aa17121',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('Feature'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: 'b004192c-70ee-4f5a-fd64-1298a0ed3b78',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('ListItem')
                                        ),
                                        data: ERecord({
                                          list: ERecord({
                                            type: EText('item'),
                                          }),
                                          text: EBoolean(false),
                                          children: EList([
                                            EElement({
                                              id: '6172fce4-3e7f-2d0c-cbd6-cb5d1af26699',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Link')
                                              ),
                                              data: ERecord({
                                                button: EBoolean(false),
                                                eventIds: EList([]),
                                                link: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Basic'),
                                                    typeName('Link')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"mode":"external","url":"#"}'
                                                  ),
                                                }),
                                                block: EText(''),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'afc274d7-2178-837c-3ef8-2c663643cdf3'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '6172fce4-3e7f-2d0c-cbd6-cb5d1af2669a',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'User Examples'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: 'b004192c-70ee-4f5a-fd64-1298a0ed3b79',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('ListItem')
                                        ),
                                        data: ERecord({
                                          list: ERecord({
                                            type: EText('item'),
                                          }),
                                          text: EBoolean(false),
                                          children: EList([
                                            EElement({
                                              id: '08305902-6545-a322-5e46-536b76cea649',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Link')
                                              ),
                                              data: ERecord({
                                                button: EBoolean(false),
                                                eventIds: EList([]),
                                                link: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Basic'),
                                                    typeName('Link')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"mode":"external","url":"#"}'
                                                  ),
                                                }),
                                                block: EText(''),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'afc274d7-2178-837c-3ef8-2c663643cdf3'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '08305902-6545-a322-5e46-536b76cea64a',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('Pricing'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: 'f757be3c-d7b1-e713-4392-30fa506ca96c',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('ListItem')
                                        ),
                                        data: ERecord({
                                          list: ERecord({
                                            type: EText('item'),
                                          }),
                                          text: EBoolean(false),
                                          children: EList([
                                            EElement({
                                              id: 'b00dc04f-babe-02aa-dc24-096ade9a8665',
                                              type: qualify(
                                                Plugins.name('Dropdown'),
                                                Component.name(
                                                  'DropdownWrapper'
                                                )
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                dropdown: ERecord({
                                                  type: EText('wrapper'),
                                                }),
                                                attr: ERecord({
                                                  'data-hover': EBoolean(false),
                                                  'data-delay': ENumber(0),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '0728d15e-0237-1200-955a-3690717e22b3'
                                                  ),
                                                ]),
                                                temp: ERecord({
                                                  dropdown: ERecord({
                                                    menu: EEnum('hide'),
                                                  }),
                                                }),
                                                children: EList([
                                                  EElement({
                                                    id: 'b00dc04f-babe-02aa-dc24-096ade9a8666',
                                                    type: qualify(
                                                      Plugins.name('Dropdown'),
                                                      Component.name(
                                                        'DropdownToggle'
                                                      )
                                                    ),
                                                    data: ERecord({
                                                      tag: EEnum('div'),
                                                      dropdown: ERecord({
                                                        type: EText('toggle'),
                                                      }),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '3899de5c-e452-4345-eecb-810516b0f7f6'
                                                        ),
                                                      ]),
                                                      children: EList([
                                                        EElement({
                                                          id: 'b00dc04f-babe-02aa-dc24-096ade9a8667',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Icon'
                                                            ),
                                                            Component.name(
                                                              'Icon'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            widget: ERecord({
                                                              type: EText(
                                                                'icon'
                                                              ),
                                                              icon: EText(
                                                                'dropdown-toggle'
                                                              ),
                                                            }),
                                                            styleBlockIds:
                                                              EList([
                                                                EText(
                                                                  'ce5a6fe5-43dd-d941-77d8-d02214336a9e'
                                                                ),
                                                              ]),
                                                            children: EList([]),
                                                          }),
                                                        }),
                                                        EElement({
                                                          id: 'b00dc04f-babe-02aa-dc24-096ade9a8668',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'Block'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            tag: EEnum('div'),
                                                            text: EBoolean(
                                                              true
                                                            ),
                                                            children: EList([
                                                              EElement({
                                                                id: 'b00dc04f-babe-02aa-dc24-096ade9a8669',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Basic'
                                                                  ),
                                                                  Component.name(
                                                                    'String'
                                                                  )
                                                                ),
                                                                data: EText(
                                                                  'Resources'
                                                                ),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                  EElement({
                                                    id: 'b00dc04f-babe-02aa-dc24-096ade9a866a',
                                                    type: qualify(
                                                      Plugins.name('Dropdown'),
                                                      Component.name(
                                                        'DropdownList'
                                                      )
                                                    ),
                                                    data: ERecord({
                                                      tag: EEnum('nav'),
                                                      dropdown: ERecord({
                                                        type: EText('list'),
                                                      }),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '16e55e89-b250-51f9-3973-7fe101c92560'
                                                        ),
                                                        EText(
                                                          'd7476783-9f65-933c-7c1b-3ee135b53baf'
                                                        ),
                                                        EText(
                                                          '765ebb9a-7c67-8b78-3c36-04a67e120ad7'
                                                        ),
                                                      ]),
                                                      children: EList([
                                                        EElement({
                                                          id: 'b00dc04f-babe-02aa-dc24-096ade9a866b',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Dropdown'
                                                            ),
                                                            Component.name(
                                                              'DropdownLink'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            dropdown: ERecord({
                                                              type: EText(
                                                                'link'
                                                              ),
                                                            }),
                                                            link: ELiteral({
                                                              name: qualify(
                                                                Plugins.name(
                                                                  'Basic'
                                                                ),
                                                                typeName('Link')
                                                              ),
                                                              value: JSON.parse(
                                                                '{"url":"#","mode":"external"}'
                                                              ),
                                                            }),
                                                            eventIds: EList([]),
                                                            styleBlockIds:
                                                              EList([
                                                                EText(
                                                                  '7b01a192-9eeb-e158-44d6-4af2632c5926'
                                                                ),
                                                              ]),
                                                            children: EList([
                                                              EElement({
                                                                id: 'b00dc04f-babe-02aa-dc24-096ade9a866c',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Basic'
                                                                  ),
                                                                  Component.name(
                                                                    'String'
                                                                  )
                                                                ),
                                                                data: EText(
                                                                  'Resource Link 1'
                                                                ),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                        EElement({
                                                          id: 'b00dc04f-babe-02aa-dc24-096ade9a866d',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Dropdown'
                                                            ),
                                                            Component.name(
                                                              'DropdownLink'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            dropdown: ERecord({
                                                              type: EText(
                                                                'link'
                                                              ),
                                                            }),
                                                            link: ELiteral({
                                                              name: qualify(
                                                                Plugins.name(
                                                                  'Basic'
                                                                ),
                                                                typeName('Link')
                                                              ),
                                                              value: JSON.parse(
                                                                '{"url":"#","mode":"external"}'
                                                              ),
                                                            }),
                                                            eventIds: EList([]),
                                                            styleBlockIds:
                                                              EList([
                                                                EText(
                                                                  '7b01a192-9eeb-e158-44d6-4af2632c5926'
                                                                ),
                                                              ]),
                                                            children: EList([
                                                              EElement({
                                                                id: 'b00dc04f-babe-02aa-dc24-096ade9a866e',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Basic'
                                                                  ),
                                                                  Component.name(
                                                                    'String'
                                                                  )
                                                                ),
                                                                data: EText(
                                                                  'Resource Link 2'
                                                                ),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                        EElement({
                                                          id: 'b00dc04f-babe-02aa-dc24-096ade9a866f',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Dropdown'
                                                            ),
                                                            Component.name(
                                                              'DropdownLink'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            dropdown: ERecord({
                                                              type: EText(
                                                                'link'
                                                              ),
                                                            }),
                                                            link: ELiteral({
                                                              name: qualify(
                                                                Plugins.name(
                                                                  'Basic'
                                                                ),
                                                                typeName('Link')
                                                              ),
                                                              value: JSON.parse(
                                                                '{"url":"#","mode":"external"}'
                                                              ),
                                                            }),
                                                            eventIds: EList([]),
                                                            styleBlockIds:
                                                              EList([
                                                                EText(
                                                                  '7b01a192-9eeb-e158-44d6-4af2632c5926'
                                                                ),
                                                              ]),
                                                            children: EList([
                                                              EElement({
                                                                id: 'b00dc04f-babe-02aa-dc24-096ade9a8670',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Basic'
                                                                  ),
                                                                  Component.name(
                                                                    'String'
                                                                  )
                                                                ),
                                                                data: EText(
                                                                  'Resource Link 3'
                                                                ),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '28fdf3bd-2bc6-7bde-01dd-d473f543221a',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('ListItem')
                                        ),
                                        data: ERecord({
                                          list: ERecord({
                                            type: EText('item'),
                                          }),
                                          text: EBoolean(false),
                                          children: EList([
                                            EElement({
                                              id: 'b3a96d53-2e6a-0ceb-f7f2-a5f2fe069f19',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                text: EBoolean(false),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '07168b85-18f5-d36e-51ee-943ecd9fc344'
                                                  ),
                                                ]),
                                                children: EList([]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '914925bc-0cf6-b92a-d095-ebfd1f98fd95',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('ListItem')
                                        ),
                                        data: ERecord({
                                          list: ERecord({
                                            type: EText('item'),
                                          }),
                                          text: EBoolean(false),
                                          children: EList([
                                            EElement({
                                              id: '01f9fb7f-f446-62d4-5bca-828d29563ba0',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Link')
                                              ),
                                              data: ERecord({
                                                button: EBoolean(false),
                                                eventIds: EList([]),
                                                link: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Basic'),
                                                    typeName('Link')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"mode":"external","url":"#"}'
                                                  ),
                                                }),
                                                block: EText(''),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'da21d2ba-fc40-8d63-33c1-570c530821a1'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '01f9fb7f-f446-62d4-5bca-828d29563ba1',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('Docs'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: 'ad933b0a-4fc6-8640-c764-e37078f7d7e6',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('ListItem')
                                        ),
                                        data: ERecord({
                                          list: ERecord({
                                            type: EText('item'),
                                          }),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              '7eaeb850-ba72-ca30-1d30-50f76271bf84'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '73e50d5d-393f-2926-ae83-98b52c168404',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Link')
                                              ),
                                              data: ERecord({
                                                button: EBoolean(true),
                                                eventIds: EList([]),
                                                link: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Basic'),
                                                    typeName('Link')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"mode":"external","url":"#"}'
                                                  ),
                                                }),
                                                block: EText(''),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '5811e2db-f107-fb36-bedc-ae019c696e30'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '73e50d5d-393f-2926-ae83-98b52c168405',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('Get Started'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '08e896a3-bb32-5cfb-f0ca-6c918ef7e7a5',
                            type: qualify(
                              Plugins.name('Navbar'),
                              Component.name('NavbarButton')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              navbar: ERecord({
                                type: EText('button'),
                              }),
                              styleBlockIds: EList([
                                EText('f2a4d0f4-6afc-44f5-843b-063d94fa1d5d'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '08e896a3-bb32-5cfb-f0ca-6c918ef7e7a6',
                                  type: qualify(
                                    Plugins.name('Icon'),
                                    Component.name('Icon')
                                  ),
                                  data: ERecord({
                                    widget: ERecord({
                                      type: EText('icon'),
                                      icon: EText('nav-menu'),
                                    }),
                                    children: EList([]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '7817eb1c-47cc-bc73-19ae-9055d6e3651f',
      type: 'class',
      name: 'Navbar Logo Left',
      comb: '',
      styleLess: '',
      children: [],
      variants: {},
    },
    {
      _id: '5092b234-0393-484c-746f-3689c63e3687',
      type: 'class',
      name: 'Navbar Logo Left Container',
      comb: '',
      styleLess:
        'z-index: 5; width: 1030px; max-width: 100%; margin-right: auto; margin-left: auto; padding-top: 15px; padding-right: 20px; padding-bottom: 15px; padding-left: 20px; background-color: transparent;',
      children: ['7ee04e3f-5f4a-63a9-0ad8-36694f4f50d9'],
      variants: {small: {styleLess: 'max-width: 100%;'}},
    },
    {
      _id: '7ee04e3f-5f4a-63a9-0ad8-36694f4f50d9',
      type: 'class',
      name: 'Shadow Three',
      comb: '&',
      styleLess:
        'width: 100%; max-width: 1140px; margin-bottom: 0px; padding-top: 20px; padding-bottom: 20px;',
      children: ['0283fe62-90df-1186-ee2b-cb537d35daff'],
      variants: {},
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: 'd9243737-6519-27e3-5f94-48a95680754d',
      type: 'class',
      name: 'Navbar Wrapper',
      comb: '',
      styleLess:
        'display: flex; justify-content: space-between; align-items: center;',
      children: [],
      variants: {},
    },
    {
      _id: 'c447af01-1144-3fbb-1b22-b79b330b748d',
      type: 'class',
      name: 'Navbar Brand',
      comb: '',
      styleLess: '',
      children: [],
      variants: {small: {styleLess: 'padding-left: 0px;'}},
    },
    {
      _id: '0a4327ab-4bc9-e91e-1ec2-996cd50f31d5',
      type: 'class',
      name: 'Nav Menu Wrapper',
      comb: '',
      styleLess: '',
      children: [],
      variants: {medium: {styleLess: 'background-color: transparent;'}},
    },
    {
      _id: 'c567917e-2cd3-7da4-4a7a-22de5ae608f4',
      type: 'class',
      name: 'Nav Menu Two',
      comb: '',
      styleLess:
        'display: flex; margin-bottom: 0px; justify-content: space-between; align-items: center;',
      children: [],
      variants: {
        medium: {
          styleLess:
            'display: flex; margin-top: 10px; padding-top: 20px; padding-right: 20px; padding-bottom: 20px; padding-left: 20px; justify-content: space-around; flex-wrap: wrap; align-items: center; border-top-left-radius: 50px; border-top-right-radius: 50px; border-bottom-left-radius: 50px; border-bottom-right-radius: 50px; background-color: hsla(0, 0.00%, 100.00%, 1.00); box-shadow: 0 8px 50px 0 hsla(0, 0.00%, 0.00%, 0.05);',
        },
        tiny: {styleLess: 'flex-direction: column;'},
        small: {
          styleLess:
            'padding-bottom: 30px; flex-direction: column; border-top-left-radius: 20px; border-top-right-radius: 20px; border-bottom-left-radius: 20px; border-bottom-right-radius: 20px;',
        },
      },
    },
    {
      _id: 'afc274d7-2178-837c-3ef8-2c663643cdf3',
      type: 'class',
      name: 'Nav Link',
      comb: '',
      styleLess:
        'margin-right: 5px; margin-left: 5px; padding-top: 5px; padding-right: 10px; padding-bottom: 5px; padding-left: 10px; color: #1a1b1f; font-size: 14px; line-height: 20px; letter-spacing: 0.25px; text-decoration: none;',
      children: [],
      variants: {
        small: {
          styleLess:
            'display: inline-block; padding-top: 10px; padding-bottom: 10px;',
        },
        'main_focus-visible': {
          styleLess:
            'border-top-left-radius: 4px; border-top-right-radius: 4px; border-bottom-left-radius: 4px; border-bottom-right-radius: 4px; outline-color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00); outline-offset: 0px; outline-style: solid; outline-width: 2px; color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00);',
        },
        medium: {styleLess: 'padding-right: 5px; padding-left: 5px;'},
        main_hover: {styleLess: 'color: rgba(26, 27, 31, 0.75);'},
      },
    },
    {
      _id: '0728d15e-0237-1200-955a-3690717e22b3',
      type: 'class',
      name: 'Nav Dropdown',
      comb: '',
      styleLess: 'margin-right: 5px; margin-left: 5px;',
      children: [],
      variants: {
        small: {
          styleLess:
            'display: flex; flex-direction: column; align-items: center;',
        },
      },
    },
    {
      _id: '3899de5c-e452-4345-eecb-810516b0f7f6',
      type: 'class',
      name: 'Nav Dropdown Toggle',
      comb: '',
      styleLess:
        'padding-top: 5px; padding-right: 30px; padding-bottom: 5px; padding-left: 10px; font-size: 14px; line-height: 20px; letter-spacing: 0.25px;',
      children: [],
      variants: {
        main_hover: {styleLess: 'color: rgba(26, 27, 31, 0.75);'},
        small: {styleLess: 'padding-top: 10px; padding-bottom: 10px;'},
        'main_focus-visible': {
          styleLess:
            'border-top-left-radius: 5px; border-top-right-radius: 5px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; outline-color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00); outline-offset: 0px; outline-style: solid; outline-width: 2px; color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00);',
        },
      },
    },
    {
      _id: 'ce5a6fe5-43dd-d941-77d8-d02214336a9e',
      type: 'class',
      name: 'Nav Dropdown Icon',
      comb: '',
      styleLess: 'margin-right: 10px;',
      children: [],
      variants: {},
    },
    {
      _id: '16e55e89-b250-51f9-3973-7fe101c92560',
      type: 'class',
      name: 'Nav Dropdown List',
      comb: '',
      styleLess:
        'border-top-left-radius: 12px; border-top-right-radius: 12px; border-bottom-left-radius: 12px; border-bottom-right-radius: 12px; background-color: white;',
      children: ['d7476783-9f65-933c-7c1b-3ee135b53baf'],
      variants: {
        main_open: {styleLess: 'padding-top: 10px; padding-bottom: 10px;'},
      },
    },
    {
      _id: 'd7476783-9f65-933c-7c1b-3ee135b53baf',
      type: 'class',
      name: 'Shadow Three',
      comb: '&',
      styleLess: '',
      children: ['765ebb9a-7c67-8b78-3c36-04a67e120ad7'],
      variants: {
        medium_open: {styleLess: 'position: absolute;'},
        small_open: {styleLess: 'position: relative;'},
        small: {
          styleLess: 'box-shadow: 0 8px 50px 0 hsla(0, 0.00%, 0.00%, 0.05);',
        },
      },
    },
    {
      _id: '765ebb9a-7c67-8b78-3c36-04a67e120ad7',
      type: 'class',
      name: 'Mobile Shadow Hide',
      comb: '&',
      styleLess: '',
      children: [],
      variants: {
        small: {
          styleLess:
            'box-shadow: none /* 0 8px 50px 0 hsla(0, 0.00%, 0.00%, 0.05) */;',
        },
      },
    },
    {
      _id: '7b01a192-9eeb-e158-44d6-4af2632c5926',
      type: 'class',
      name: 'Nav Dropdown Link',
      comb: '',
      styleLess: 'padding-top: 5px; padding-bottom: 5px; font-size: 14px;',
      children: [],
      variants: {
        'main_focus-visible': {
          styleLess:
            'border-top-left-radius: 5px; border-top-right-radius: 5px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; outline-color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00); outline-offset: 0px; outline-style: solid; outline-width: 2px; color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00);',
        },
      },
    },
    {
      _id: '07168b85-18f5-d36e-51ee-943ecd9fc344',
      type: 'class',
      name: 'Nav Divider',
      comb: '',
      styleLess:
        'width: 1px; height: 22px; margin-right: 15px; margin-left: 15px; background-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'width: 200px; height: 1px; max-width: 100%; margin-top: 10px; margin-bottom: 10px;',
        },
      },
    },
    {
      _id: 'da21d2ba-fc40-8d63-33c1-570c530821a1',
      type: 'class',
      name: 'Nav Link Accent',
      comb: '',
      styleLess:
        'margin-right: 20px; margin-left: 5px; padding-top: 5px; padding-right: 10px; padding-bottom: 5px; padding-left: 10px; color: #1a1b1f; font-size: 14px; line-height: 20px; font-weight: 700; letter-spacing: 0.25px; text-decoration: none;',
      children: [],
      variants: {
        small: {
          styleLess:
            'display: inline-block; margin-right: 5px; padding-top: 10px; padding-bottom: 10px;',
        },
        main_hover: {styleLess: 'color: rgba(26, 27, 31, 0.75);'},
      },
    },
    {
      _id: '7eaeb850-ba72-ca30-1d30-50f76271bf84',
      type: 'class',
      name: 'Mobile Margin Top 10',
      comb: '',
      styleLess: '',
      children: [],
      variants: {small: {styleLess: 'margin-top: 10px;'}},
    },
    {
      _id: '5811e2db-f107-fb36-bedc-ae019c696e30',
      type: 'class',
      name: 'Button Primary',
      comb: '',
      styleLess:
        'padding-top: 12px; padding-right: 25px; padding-bottom: 12px; padding-left: 25px; background-color: #1a1b1f; transition-property: all; transition-duration: 200ms; transition-timing-function: ease; color: hsla(0, 0.00%, 100.00%, 1.00); font-size: 12px; line-height: 20px; letter-spacing: 2px; text-transform: uppercase;',
      children: [
        '7a50e611-1678-13fa-5f6c-0c95173beacf',
        '0333fb64-65a4-0eb3-2546-375483e0a446',
      ],
      variants: {
        main_hover: {
          styleLess:
            'background-color: #32343a; color: hsla(0, 0.00%, 100.00%, 1.00);',
        },
        main_active: {styleLess: 'background-color: #43464d;'},
      },
    },
    {
      _id: 'f2a4d0f4-6afc-44f5-843b-063d94fa1d5d',
      type: 'class',
      name: 'Menu button',
      comb: '',
      styleLess: '',
      children: [],
      variants: {
        medium_open: {
          styleLess:
            'background-color: hsla(213.60000000000002, 16.34%, 70.00%, 1.00); color: hsla(0, 0.00%, 100.00%, 1.00);',
        },
        medium: {
          styleLess:
            'padding-top: 12px; padding-right: 12px; padding-bottom: 12px; padding-left: 12px;',
        },
      },
    },
  ],
} as const;
